'use strict';

import $ from 'jquery';
import autocomplete from 'jquery-ui/ui/widgets/autocomplete';

// These are strings expected by dtd in the status field.
const DTD_NOT_FOUND = 'not_found';
const DTD_NO_INTERACTION = "no_interaction";
const DTD_FOUND = "found";

/**
 * Code to work with the Double the Donation system.
 */
let dtd = (function () {
  let pub = {
    companyId: null,
    dtdStatus: DTD_NO_INTERACTION,
    pledgeTotalFunc: null,
    validateCompany: function () { }
  };

  let priv = {
    $companySearch: $('#company'),
    $emailAddress: $('#email-address'),
    $companyNotFoundError: $('<label id="company-not-found-error" class="company-error">Your company does not currently match donations to Twin Cities PBS.</label>'),
    $companyIneligibleError: $('<label id="company-ineligible-error" class="company-error">Your company requires a minimum donation for matching. To qualify, increase your donation to <span class="minimum-total-for-match"></span>.</label>'),
    companies: []
  };

  // If we don't have a company field (custom forms), we we don't have to do anything.
  if (priv.$companySearch.length === 0) {
    return pub;
  }

  // Custom forms has the email named differently.
  if (priv.$emailAddress.length === 0) {
    priv.$emailAddress = $('#email');
  }

  // Append the errors to the field and prepend the message.  This is so custom forms and
  // donation can have the same logic.
  priv.$companySearch.before($('<p><strong>Double Your Impact! See if your company will match your donation by searching/selecting here:</strong></p>'));
  priv.$companySearch.after(priv.$companyNotFoundError);
  priv.$companyNotFoundError.after(priv.$companyIneligibleError);

  /**
   * Validates a company and shows appropriate error messaging in necessary.
   */
  pub.validateCompany = function () {
    priv.$companyNotFoundError.hide();
    priv.$companyIneligibleError.hide();

    // If we have a company ID, get its info and see if the minimum has been met.  If we have
    // a value in the field but no ID, show the message that the company doesn't match.
    if (priv.$companySearch.val() !== '' && pub.companyId === null) {
      priv.$companyNotFoundError.show();
      pub.dtdStatus = DTD_NOT_FOUND;
    } else if (pub.companyId !== null) {
      pub.dtdStatus = DTD_FOUND;

      // Get the company info to see if enough has been donated.
      $.get('/dtdCompany/' + pub.companyId, function (data) {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = {};
        }

        // We may have had a problem getting the information from DTD.
        if (typeof data.minimum_matched === 'undefined') {
          data.minimum_matched = '';
        }

        if (data.minimum_matched !== '' && pub.pledgeTotalFunc() < parseFloat(data.minimum_matched.substr(1))) {
          priv.$companyIneligibleError.find('.minimum-total-for-match').html(data.minimum_matched);
          priv.$companyIneligibleError.show();
        }
      });
    }
  };

  /**
   * Does company select logic in the auto-complete
   *
   * @param {JQuery) $this
   * @param {Event} e
   * @param {Object} ui
   */
  priv.selectCompany = function ($this, e, ui) {
    e.preventDefault();

    pub.companyId = ui.item.value;
    $this.val(ui.item.label);
  };

  // Initialization.
  priv.$companySearch.autocomplete({
    source: function (request, response) {
      $.get('/dtdCompanies/' + request.term, function (data) {
        try {
          priv.companies = JSON.parse(data);
        } catch (e) {
          priv.companies = [];
        }

        response(priv.companies);
      });
    },
    minLength: 2,
    select: function (e, ui) {
      priv.selectCompany($(this), e, ui);
    },
    focus: function (e, ui) {
      priv.selectCompany($(this), e, ui);
    }
  });

  priv.$companySearch.blur(function (e) {
    let companyVal = priv.$companySearch.val();

    // See if it is in the list that was retrieved.  If not, the company ID shouldn't be set.
    pub.companyId = null;

    for (let companyI in priv.companies) {
      if (priv.companies.hasOwnProperty(companyI)) {
        let company = priv.companies[companyI];

        if (companyVal.toLowerCase() === company.label.toLowerCase()) {
          pub.companyId = company.value;
          break;
        }
      }
    }

    pub.validateCompany();
  });

  priv.$emailAddress.blur(function (e) {
    if (pub.companyId === null && priv.$emailAddress.val()) {
      $.get('/dtdEmailMatch/' + priv.$emailAddress.val(), function (data) {
        let company;

        try {
          company = JSON.parse(data);
        } catch (e) {
          company = {};
        }

        // The call to DTD may have failed or there may be no match.
        if (typeof company.id !== 'undefined') {
          pub.companyId = company.id;
          priv.$companySearch.val(company.company_name);
        }
      });
    }
  });

  return pub;
})();

export default dtd